
const $7b739dc893b16204$var$idNumber = document.querySelector(".id-number");
const $7b739dc893b16204$var$adviceText = document.querySelector(".text");
const $7b739dc893b16204$var$diceBtn = document.querySelector(".dice-btn");
$7b739dc893b16204$var$diceBtn.addEventListener("click", $7b739dc893b16204$var$handleClick);
function $7b739dc893b16204$var$handleClick() {
    fetch("https://api.adviceslip.com/advice", {
        cache: "no-cache"
    }, {
        mode: "cors"
    }).then((response)=>{
        return response.json();
    }).then((response)=>{
        $7b739dc893b16204$var$idNumber.textContent = `${response.slip.id}`;
        $7b739dc893b16204$var$adviceText.textContent = `${response.slip.advice}`;
    }).catch((err)=>{
        console.error(err);
    });
}


console.log("Parcel is working. Hurray!");


//# sourceMappingURL=index.7954d692.js.map
